export default defineNuxtRouteMiddleware(async (to, from) => {
  const currentPath = from.fullPath
  const nextPath = to.fullPath
  if (nextPath === "/order/new?is_confirm=true" && currentPath !== "/order/new") {
    return await navigateTo("/order/new")
  }
})
